import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-prix-produit-cond-type-client-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "text-black fw-semibold" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-12 mt-3" }
const _hoisted_13 = { class: "border border-primary mb-10" }
const _hoisted_14 = { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold p-2 bg-primary" }
const _hoisted_15 = { class: "col-md-5" }
const _hoisted_16 = { class: "d-flex float-end" }
const _hoisted_17 = { class: "p-3" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "px-3" }
const _hoisted_20 = { class: "col-md-10" }
const _hoisted_21 = { class: "form-group mt-2" }
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "col-md-2 mt-2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "col-md-12 my-3" }
const _hoisted_26 = { class: "border border-primary p-0" }
const _hoisted_27 = { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold p-2 bg-primary" }
const _hoisted_28 = { class: "col-md-7" }
const _hoisted_29 = { class: "fs-6 text-white" }
const _hoisted_30 = { class: "col-md-5" }
const _hoisted_31 = { class: "d-flex float-end" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "p-3" }
const _hoisted_34 = { class: "col-md-5" }
const _hoisted_35 = { class: "form-group mb-2" }
const _hoisted_36 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = { class: "form-group mb-2" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = { class: "form-group mb-2" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_44 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_45 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_46 = { class: "col-md-2" }
const _hoisted_47 = { class: "form-group mb-2" }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { class: "col-md-1" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "col-md-12 mt-5" }
const _hoisted_52 = { class: "d-flex align-items-center" }
const _hoisted_53 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, " Définir un prix pour " + _toDisplayString(_ctx.produit?.nomProd || 'le produit'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Form, {
        ref: "prixProduitCondTypeClientForm",
        onSubmit: _ctx.addPrixProduitCondTypeClient,
        "validation-schema": _ctx.prixProduitCondTypeClientSchema,
        "keep-values": _ctx.valuess
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date de définition "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateDefinition",
                  type: "date",
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Sélectionner la date de définition",
                  readonly: ""
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateDefinition",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Groupe de Taxe"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "groupe" }, {
                  default: _withCtx(({ setValue }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.groupeOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.groupe,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.groupe) = $event)),
                        (val) => { setValue(val); _ctx.onGroupeSelect(val); }
                      ],
                      placeholder: "Sélectionner un groupe"
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "groupe",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Mode de définition"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "mode" }, {
                  default: _withCtx(({ setValue }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.modeOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mode) = $event)),
                        (val) => { setValue(val); }
                      ],
                      disabled: _ctx.estRedonly,
                      placeholder: "Sélectionner le mode de définition"
                    }, null, 8, ["options", "modelValue", "disabled", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "mode",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-7" }, [
                    _createElementVNode("h4", { class: "fs-4 mx-1 text-white" }, "Définir les prix par catégorie client")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "btn btn-success",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addRowCategorie && _ctx.addRowCategorie(...args)))
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                        _createTextVNode(" Ajouter une catégorie client ")
                      ]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (categorie, categorieIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: categorieIndex,
                          class: "row gy-0 border border-primary mb-3"
                        }, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold px-2 py-2 bg-primary" }, [
                            _createElementVNode("div", { class: "col-md-7" }, [
                              _createElementVNode("h5", { class: "fs-6 mx-1 text-white" }, "Sélectionner les catégories clients")
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.getCategorieClientOptions(categorieIndex),
                                searchable: true,
                                "track-by": "value",
                                label: "label",
                                modelValue: categorie.categorie,
                                "onUpdate:modelValue": ($event: any) => ((categorie.categorie) = $event),
                                placeholder: "Sélectionner la catégorie client",
                                disabled: false,
                                onSelect: ($event: any) => (_ctx.selectCategorie(categorie.categorie, categorie))
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                              (_ctx.validatePrixRow(categorie.categorie))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, " La catégorie client est obligatoire. "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("button", {
                              class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeRowCategorie(categorieIndex))
                            }, _cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                            ]), 8, _hoisted_24)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("h5", _hoisted_29, " Ajouter les prix pour " + _toDisplayString(categorie.nomCategorie || 'la catégorie'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-success",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.addRowPrix(categorieIndex))
                                    }, _cache[9] || (_cache[9] = [
                                      _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                                      _createTextVNode(" Ajouter un prix ")
                                    ]), 8, _hoisted_32)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row mt-10" }, [
                                  _createElementVNode("div", { class: "col-md-5" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                      _createTextVNode(" Produit Conditionnement "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "col-md-2" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Prix Min (XOF) ")
                                  ]),
                                  _createElementVNode("div", { class: "col-md-2" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                      _createTextVNode(" Prix de Vente (XOF) "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "col-md-2" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, " Prix Max (XOF) ")
                                  ]),
                                  _createElementVNode("div", { class: "col-md-1" }, [
                                    _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Action")
                                  ])
                                ], -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorie.prixList, (prix, prixIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "row gy-0",
                                    key: prixIndex
                                  }, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createVNode(_component_Multiselect, {
                                          options: _ctx.produitConditionnementOptions,
                                          searchable: true,
                                          "track-by": "value",
                                          label: "label",
                                          modelValue: prix.produitConditionnement,
                                          "onUpdate:modelValue": ($event: any) => ((prix.produitConditionnement) = $event),
                                          placeholder: "Sélectionner le produit conditionnement",
                                          onSelect: ($event: any) => (_ctx.selectProduitConditionnement(prix.produitConditionnement, prix))
                                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"]),
                                        (_ctx.validatePrixRow(prix.produitConditionnement))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Le produit conditionnement est obligatoire. "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          "onUpdate:modelValue": ($event: any) => ((prix.prixMin) = $event),
                                          step: "0.01",
                                          min: "0",
                                          class: "form-control shadow-none fs-md-15 text-black"
                                        }, null, 8, _hoisted_39), [
                                          [_vModelText, prix.prixMin]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          "onUpdate:modelValue": ($event: any) => ((prix.prix) = $event),
                                          step: "0.01",
                                          min: "0",
                                          class: _normalizeClass([
                                    _ctx.validatePrixRow(prix.prix) || prix.prix < prix.prixMin || prix.prix > prix.prixMax
                                      ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                      : 'form-control shadow-none fs-md-15 text-black'
                                  ]),
                                          placeholder: "Entrez le prix en Francs CFA"
                                        }, null, 10, _hoisted_42), [
                                          [_vModelText, prix.prix]
                                        ]),
                                        (_ctx.validatePrixRow(prix.prix))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Le prix est obligatoire. "))
                                          : _createCommentVNode("", true),
                                        (prix.prix < prix.prixMin)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Le prix doit être supérieur ou égal au prix minimum. "))
                                          : _createCommentVNode("", true),
                                        (prix.prix > prix.prixMax)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Le prix doit être inférieur ou égal au prix maximum. "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "number",
                                          "onUpdate:modelValue": ($event: any) => ((prix.prixMax) = $event),
                                          step: "0.01",
                                          min: "0",
                                          class: "form-control shadow-none fs-md-15 text-black"
                                        }, null, 8, _hoisted_48), [
                                          [_vModelText, prix.prixMax]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("button", {
                                        class: "btn btn-danger transition border-0 pb-2 ps-4 pe-4",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.removeRowPrix(categorieIndex, prixIndex))
                                      }, _cache[10] || (_cache[10] = [
                                        _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                      ]), 8, _hoisted_50)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Ajouter un prix produit conditionnement ", 10, _hoisted_53),
                _createVNode(_component_router_link, {
                  to: "/prixproduits/liste-prixproduits",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, "Annuler", -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "keep-values"])
    ])
  ]))
}